import { useEffect, useRef } from 'react';

import { useIntl } from 'react-intl-next';

import { useLogException } from '../error-boundary/utils';
import { getJiraIssueTypesFilter } from '../filters/selected/utils';
import {
	useAnalyticsAttributes,
	useCloudId,
	useIsTypeFilteredToIncident,
	usePrimaryProduct,
} from '../store/bootstrap';
import { useJsmIncidentFilterIds, useSearchActions } from '../store/search';

export const FetchJsmIncidentFilterIds = () => {
	const [cloudId] = useCloudId();
	const intl = useIntl();
	const isTypeFilteredToIncident = useIsTypeFilteredToIncident();
	// eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
	const jiraIssueTypeFilters = useJsmIncidentFilterIds();
	const isFetching = useRef<boolean>(false);
	const { setJsmIncidentFilterIds } = useSearchActions();
	const logException = useLogException();
	const hasJiraIssueTypeFilters = jiraIssueTypeFilters.length > 0;
	const [analyticsAttributes] = useAnalyticsAttributes();
	const [primaryProduct] = usePrimaryProduct();

	useEffect(() => {
		async function fetchJiraIssueTypesFilter() {
			// Only fetch when filtered to incident
			if (!isTypeFilteredToIncident) {
				return;
			}

			// Only fetch if not yet available (don't over-fetch!)
			if (isFetching.current || hasJiraIssueTypeFilters) {
				return;
			}

			isFetching.current = true;
			try {
				const jsmIncidentId = await getJiraIssueTypesFilter(
					cloudId,
					intl,
					'incident',
					analyticsAttributes?.activationId,
					primaryProduct,
				);

				setJsmIncidentFilterIds([jsmIncidentId]);
			} catch (e) {
				logException(e);
			} finally {
				isFetching.current = false;
			}
		}
		fetchJiraIssueTypesFilter();
	}, [
		cloudId,
		intl,
		isTypeFilteredToIncident,
		hasJiraIssueTypeFilters,
		logException,
		setJsmIncidentFilterIds,
		analyticsAttributes?.activationId,
		primaryProduct,
	]);

	return null;
};
